import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { LOAD } = SNOWPLOW_EVENTS;

interface TriggerAiCompanionExampleChatLoadedEventParams {
	exampleChats: string[];
}

export const triggerAiCompanionExampleChatLoadedEvent = ({
	exampleChats,
}: TriggerAiCompanionExampleChatLoadedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		customData: { label: JSON.stringify(exampleChats) },
		name: 'dlr_ai_companion_example_chat_loaded',
		schemaName: LOAD.SCHEMA,
		version: LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
